var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M125.8,2.7c-0.4,0.1-26.3,21-57.6,46.4C6.4,99.3,8.7,97.2,10.8,101.4c1.3,2.9,3.8,3.7,10.6,3.7h5.6v57.6v57.6h-6.4c-6.3,0-6.4,0.1-8.3,1.7l-1.9,1.7V237v13.3l1.9,1.7l1.9,1.7h114h114l1.9-1.7l1.9-1.7V237v-13.3l-1.9-1.7c-1.9-1.6-2-1.7-8.3-1.7h-6.4v-57.6v-57.6h5.6c6.8,0,9.2-0.9,10.6-3.7c2-4.2,4.4-2.1-57.5-52.3C156.5,23.8,130.5,2.8,130,2.7C128.9,2.3,126.9,2.3,125.8,2.7z M102.9,162.7v57.6H89.7H76.6v-57.6v-57.6h13.2h13.2V162.7L102.9,162.7z M179.4,162.7v57.6h-13.2h-13.2v-57.6v-57.6h13.2h13.2V162.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.d31b556cf372961de3b4694fb9d492b5.svg";
export { ForwardRef as ReactComponent };